module.exports = __webpack_public_path__ + "media/reskin-images/icon--modules-0ac144c1.svg";